import { render, staticRenderFns } from "./VTd.vue?vue&type=template&id=0f8cee2c&scoped=true&"
import script from "./VTd.vue?vue&type=script&lang=js&"
export * from "./VTd.vue?vue&type=script&lang=js&"
import style0 from "./VTd.vue?vue&type=style&index=0&id=0f8cee2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8cee2c",
  null
  
)

export default component.exports